import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// ── Service worker (production only) ──────────────────────────────────
// skipWaiting + clientsClaim let a new SW take over without forcing a
// reload — we surface a "new version" toast instead so the user can
// finish the current question before reloading.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Fires when a new SW has installed and is waiting.
      reg.addEventListener('updatefound', () => {
        const sw = reg.installing
        if (!sw) return
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            // A new version is ready; old SW still controls the page.
            window.dispatchEvent(new CustomEvent('app:sw-update', { detail: { sw } }))
          }
        })
      })

      // Periodic check (every 30 min) so background sessions pick up new builds.
      setInterval(() => reg.update().catch(() => {}), 30 * 60_000)
    }).catch((err) => console.warn('SW registration failed:', err))

    // Fired when this page starts being controlled by a new SW (after SKIP_WAITING).
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      refreshing = true
      window.location.reload()
    })
  })
}
